import axiosInstance from "./axiosInstance.jsx";

const prefix = "/api/project-tracker";

export async function trackerApi(path, options = {}) {
  const config = { ...options };
  if (options.body !== undefined) {
    config.data = options.body;
    delete config.body;
  }
  if (options.method) config.method = options.method;

  const response = await axiosInstance.request({
    url: `${prefix}${path}`,
    ...config,
  });
  return response.data;
}

export async function trackerDownload(path, fallbackName) {
  const response = await axiosInstance.get(`${prefix}${path}`, {
    responseType: "blob",
  });

  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const name = match?.[1] || fallbackName;

  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
